

import Footer from './Footer.js';

// css imports
import styles from './footer.module.css';





export default Footer;


export {
  styles
};
